export default {
  title: 'ภาษา',
  dataTitle: 'ข้อมูลภาษา',
  selectLanguage: 'เลือกภาษา',
  th: 'ไทย',
  en: 'อังกฤษ'
}
